import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { useSelector } from 'modules/react-redux';
import { useMemo } from 'react';
import { useNetSuiteExpensesFieldSettings, useNetSuiteItemsFieldSettings } from 'shared/hooks/(requests)';

export const useNetSuiteLineFieldSettings = (
    companyId: string,
    integrationCode: domain.IntegrationCode,
    lineType: domain.NetSuiteMatchingLineType | undefined
) => {
    const companyTemplates = useSelector((state) =>
        selectors.template.getIntegrationTemplatesByCompanyId(state, companyId)
    );

    const template = useMemo(() => {
        return companyTemplates.find((template) => template.integrationCode === integrationCode);
    }, [integrationCode, companyTemplates]);

    const expenseLinesFieldSettings = useNetSuiteExpensesFieldSettings(template?.documentFields);

    const itemLinesFieldSettings = useNetSuiteItemsFieldSettings(template?.documentFields);

    return lineType === domain.NetSuiteMatchingLineType.Expense ? expenseLinesFieldSettings : itemLinesFieldSettings;
};
